// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { PostLoginData, PostLoginResponses, PostLogoutData, PostLogoutResponses, PostPasswordEmailkeyData, PostPasswordEmailkeyResponses, PostPasswordUpdateData, PostPasswordUpdateResponses, PostRefreshTokenData, PostRefreshTokenResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Authenticate user, handle lockout, return access token in body, refresh token as cookie.
 */
export const postLogin = <ThrowOnError extends boolean = false>(options?: Options<PostLoginData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostLoginResponses, unknown, ThrowOnError>({
        url: '/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Logout by revoking the refresh token and clearing the associated http cookie.
 */
export const postLogout = <ThrowOnError extends boolean = false>(options?: Options<PostLogoutData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostLogoutResponses, unknown, ThrowOnError>({
        url: '/logout',
        ...options
    });
};

/**
 * Trigger a password reset email to be sent to the user with the provided user_id.
 *
 * The generated email will provide a URL link containing a short-lived JWT
 * for the user to reset their password.
 */
export const postPasswordEmailkey = <ThrowOnError extends boolean = false>(options?: Options<PostPasswordEmailkeyData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostPasswordEmailkeyResponses, unknown, ThrowOnError>({
        url: '/password/emailkey',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reset the user's password using a JWT key value provided via email.
 */
export const postPasswordUpdate = <ThrowOnError extends boolean = false>(options?: Options<PostPasswordUpdateData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostPasswordUpdateResponses, unknown, ThrowOnError>({
        url: '/password/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Exchange a valid refresh token cookie for a new access token.
 */
export const postRefreshToken = <ThrowOnError extends boolean = false>(options?: Options<PostRefreshTokenData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostRefreshTokenResponses, unknown, ThrowOnError>({
        url: '/refresh/token',
        ...options
    });
};
